import * as actionTypes from '../../app/utils/constants/ActionTypes'

const initialState = {
    currentPage: "",
    previousPage: null,
    dropdowns: {
      reportExpand: false,
      socialExpand: false,
      performanceExpand: false,
      campaignExpand: false,
      summariesExpand: false
    },
    styles: {

    }
};


const sidebar = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.DROPDOWN_CHANGE:
            return {
                ...state,
                ...action.properties
            }
        default:
            return state

    }
}

export { initialState }

export default sidebar